import React, { useState } from "react";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ScholarDashboard() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState("home");

  async function handleLogout() {
    await signOut(auth);
    navigate("/login");
  }

  const sessions = [
    { number: "01", title: "Lead NOW", status: "active" },
    { number: "02", title: "Lead RIGHT", status: "locked" },
    { number: "03", title: "Lead SMART", status: "locked" },
    { number: "04", title: "Lead TOGETHER", status: "locked" },
    { number: "05", title: "Lead FORWARD", status: "locked" },
  ];

  const initials = `${userProfile?.firstName?.[0] || ""}${userProfile?.lastName?.[0] || ""}`;
  const currentSession = userProfile?.currentSession || 1;
  const progressPercent = Math.round((currentSession / 5) * 100);

  const ScriptureCard = () => (
    <div style={{ background: "#060D1A", borderRadius: 12, padding: "20px 24px", borderLeft: "3px solid #C9A84C", margin: "16px 0 0" }}>
      <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 10, color: "#C9A84C", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.5, marginBottom: 10 }}>Matthew 20:26-28</div>
      <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.85)", lineHeight: 1.8, fontStyle: "italic" }}>
        "But among you it will be different. Whoever wants to be a leader among you must be your servant, and whoever wants to be first among you must become your slave. For even the Son of Man came not to be served but to serve others and to give his life as a ransom for many."
      </div>
    </div>
  );

  const ProgressView = () => (
    <div>
      <div style={{ background: "#fff", borderRadius: 14, padding: "20px 24px", border: "1px solid #f0f0f0", marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
          <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 20, fontWeight: 600, color: "#060D1A" }}>Your Journey</div>
          <div style={{ background: "#fef9ec", border: "1.5px solid #C9A84C", borderRadius: 999, padding: "4px 14px", fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 700, color: "#C9A84C" }}>{progressPercent}% Complete</div>
        </div>
        <div style={{ background: "#f0f0f0", borderRadius: 999, height: 8, marginBottom: 20 }}>
          <div style={{ background: "#C9A84C", borderRadius: 999, height: 8, width: `${progressPercent}%`, transition: "width 0.5s ease" }} />
        </div>
        {sessions.map((session, index) => (
          <div key={session.number} style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 0", borderBottom: index < sessions.length - 1 ? "1px solid #f0f0f0" : "none", opacity: session.status === "locked" ? 0.35 : 1 }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: session.status === "active" ? "#C9A84C" : "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 700, color: session.status === "active" ? "#fff" : "#999", flexShrink: 0 }}>{session.number}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 700, color: "#060D1A" }}>{session.title}</div>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#888", marginTop: 2 }}>{session.status === "active" ? "In progress" : "Locked"}</div>
            </div>
            {session.status === "active" && (
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 10, color: "#0038A8", fontWeight: 700, background: "rgba(0,56,168,0.08)", padding: "3px 10px", borderRadius: 999 }}>Active</div>
            )}
            {session.status === "locked" && <span style={{ fontSize: 14 }}>🔒</span>}
          </div>
        ))}
      </div>
      <ScriptureCard />
    </div>
  );

  const HomeView = () => (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 24, fontWeight: 600, color: "#060D1A", marginBottom: 4 }}>
          You Can Lead NOW
        </div>
        <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: "#888" }}>
          What leadership is. How to lead yourself first. The inside-out model.
        </div>
      </div>

      <div className="sd-cards-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 20 }}>
        <div className="sd-card">
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 700, color: "#060D1A", marginBottom: 6 }}>Identity Statement</div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#888", marginBottom: 16, lineHeight: 1.6 }}>Who you are as a leader in your own words.</div>
          <button className="sd-card-btn" onClick={() => navigate("/scholar/identity")}>View and Edit</button>
        </div>
        <div className="sd-card">
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 700, color: "#060D1A", marginBottom: 6 }}>Proof Practice</div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#888", marginBottom: 16, lineHeight: 1.6 }}>Your 21-day practice to prove your identity is real.</div>
          <button className="sd-card-btn">Open Tracker</button>
        </div>
        <div className="sd-card">
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 700, color: "#060D1A", marginBottom: 6 }}>Session Reflection</div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#888", marginBottom: 16, lineHeight: 1.6 }}>Submit your end of session reflection.</div>
          <button className="sd-card-btn">Submit</button>
        </div>
      </div>

      <div className="sd-card">
        <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 700, color: "#060D1A", marginBottom: 12 }}>Your Progress</div>
        <div style={{ background: "#f0f0f0", borderRadius: 999, height: 8, marginBottom: 8 }}>
          <div style={{ background: "#C9A84C", borderRadius: 999, height: 8, width: `${progressPercent}%` }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#999" }}>Session {currentSession} of 5</div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#C9A84C", fontWeight: 700 }}>{progressPercent}%</div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Outfit:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Outfit', sans-serif; }
        .sd-wrap { display: flex; min-height: 100vh; }
        .sd-sidebar { width: 230px; background: #060D1A; display: flex; flex-direction: column; padding: 28px 0; flex-shrink: 0; position: fixed; height: 100vh; top: 0; left: 0; overflow: hidden; z-index: 100; }
        .sd-rings { position: absolute; bottom: -80px; right: -80px; width: 300px; height: 300px; pointer-events: none; }
        .sd-ring { position: absolute; border-radius: 50%; transform: translate(-50%, -50%); top: 50%; left: 50%; }
        .sd-main { margin-left: 230px; flex: 1; background: #f5f6fa; display: flex; flex-direction: column; min-height: 100vh; }
        .sd-topbar { background: #ffffff; padding: 16px 32px; border-bottom: 1px solid #eee; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 10; }
        .sd-content { padding: 32px; flex: 1; }
        .sd-nav-item { display: flex; align-items: center; gap: 10px; padding: 10px 16px; margin: 0 12px 4px; border-radius: 10px; cursor: pointer; transition: all 0.2s; }
        .sd-nav-active { background: rgba(0,56,168,0.15); border: 1px solid rgba(0,56,168,0.25); }
        .sd-nav-locked { opacity: 0.3; cursor: not-allowed; }
        .sd-sidebar-btn { display: flex; align-items: center; gap: 10px; padding: 10px 16px; margin: 0 12px 4px; border-radius: 10px; cursor: pointer; transition: all 0.2s; }
        .sd-sidebar-btn:hover { background: rgba(255,255,255,0.05); }
        .sd-sidebar-btn-active { background: rgba(201,168,76,0.15); border: 1px solid rgba(201,168,76,0.25); }
        .sd-card { background: #ffffff; border-radius: 14px; padding: 22px; border: 1px solid #f0f0f0; }
        .sd-card-btn { background: #0038A8; color: #fff; border: none; border-radius: 8px; padding: 9px 16px; font-family: 'Outfit', sans-serif; font-size: 11px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; cursor: pointer; }
        .sd-card-btn:hover { opacity: 0.9; }
        .sd-logout { margin: 8px 12px 0; padding: 12px; background: transparent; border: 1.5px solid rgba(255,255,255,0.15); border-radius: 10px; color: rgba(255,255,255,0.6); font-family: 'Outfit', sans-serif; font-size: 12px; font-weight: 700; cursor: pointer; text-align: center; letter-spacing: 1px; text-transform: uppercase; width: calc(100% - 24px); transition: all 0.2s; }
        .sd-logout:hover { border-color: #C9A84C; color: #C9A84C; }
        .sd-mobile-header { display: none; background: #060D1A; padding: 14px 20px; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 100; border-bottom: 1px solid rgba(255,255,255,0.07); }
        .sd-bottom-nav { display: none; background: #060D1A; padding: 12px 0 20px; position: fixed; bottom: 0; left: 0; right: 0; z-index: 100; border-top: 1px solid rgba(255,255,255,0.07); }
        .sd-bottom-nav-inner { display: flex; justify-content: space-around; align-items: center; }
        .sd-bottom-item { display: flex; flex-direction: column; align-items: center; gap: 4px; flex: 1; cursor: pointer; }
        .sd-desktop-avatar { display: flex; }
        @media (max-width: 768px) {
          .sd-sidebar { display: none; }
          .sd-main { margin-left: 0; padding-bottom: 80px; }
          .sd-mobile-header { display: flex; }
          .sd-bottom-nav { display: block; }
          .sd-topbar { position: static; }
          .sd-content { padding: 20px; }
          .sd-cards-grid { grid-template-columns: 1fr !important; }
          .sd-desktop-avatar { display: none !important; }
        }
      `}</style>

      <div className="sd-wrap">

        {/* Desktop Sidebar */}
        <div className="sd-sidebar">
          <div className="sd-rings">
            <div className="sd-ring" style={{ width: 80, height: 80, border: "1px solid rgba(201,168,76,0.15)" }} />
            <div className="sd-ring" style={{ width: 160, height: 160, border: "1px solid rgba(201,168,76,0.1)" }} />
            <div className="sd-ring" style={{ width: 260, height: 260, border: "1px solid rgba(255,255,255,0.06)" }} />
          </div>

          <div style={{ padding: "0 20px 20px", borderBottom: "1px solid rgba(255,255,255,0.07)", marginBottom: 20, position: "relative", zIndex: 1 }}>
            <div>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, fontWeight: 600, color: "#fff", letterSpacing: -0.5, lineHeight: 1 }}>LEAD</span>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 22, fontWeight: 600, color: "#0038A8", letterSpacing: -0.5, lineHeight: 1 }}>NOW</span>
            </div>
            <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: 1, marginTop: 2 }}>Student Portal</div>
          </div>

          <div style={{ flex: 1, position: "relative", zIndex: 1, overflowY: "auto" }}>
            {sessions.map((session) => (
              <div key={session.number} className={`sd-nav-item ${session.status === "active" ? "sd-nav-active" : "sd-nav-locked"}`}>
                <span style={{ color: session.status === "active" ? "#0038A8" : "#C9A84C", fontSize: 11, fontWeight: 700, minWidth: 20 }}>{session.number}</span>
                <span style={{ color: "#fff", fontSize: 12, fontWeight: session.status === "active" ? 600 : 400, flex: 1 }}>{session.title}</span>
                {session.status === "locked" && <span style={{ fontSize: 10 }}>🔒</span>}
                {session.status === "active" && <span style={{ color: "#C9A84C", fontSize: 8 }}>●</span>}
              </div>
            ))}

            <div style={{ height: 1, background: "rgba(255,255,255,0.07)", margin: "12px 16px" }} />

            <div
              className={`sd-sidebar-btn ${activeView === "progress" ? "sd-sidebar-btn-active" : ""}`}
              onClick={() => setActiveView(activeView === "progress" ? "home" : "progress")}
            >
              <span style={{ color: activeView === "progress" ? "#C9A84C" : "rgba(255,255,255,0.5)", fontSize: 12, fontWeight: 600 }}>Your Progress</span>
              <span style={{ color: activeView === "progress" ? "#C9A84C" : "rgba(255,255,255,0.3)", fontSize: 10, marginLeft: "auto" }}>{progressPercent}%</span>
            </div>
          </div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <button className="sd-logout" onClick={handleLogout}>Sign Out</button>
          </div>
        </div>

        <div className="sd-main">

          {/* Mobile Header */}
          <div className="sd-mobile-header">
            <div>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 20, fontWeight: 600, color: "#fff", letterSpacing: -0.5, lineHeight: 1 }}>LEAD</span>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 20, fontWeight: 600, color: "#0038A8", letterSpacing: -0.5, lineHeight: 1 }}>NOW</span>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 8, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: 1, marginTop: 1 }}>Student Portal</div>
            </div>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#0038A8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", fontFamily: "'Outfit', sans-serif", border: "1.5px solid rgba(255,255,255,0.15)" }}>
              {initials || "S"}
            </div>
          </div>

          {/* Top Bar */}
          <div className="sd-topbar">
            <div>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 16, fontWeight: 700, color: "#060D1A" }}>
                Welcome, {userProfile?.firstName || "Scholar"}
              </div>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#999" }}>
                Pasig Student Scholars · Batch 1
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ display: "inline-block", background: "rgba(0,56,168,0.08)", border: "1px solid rgba(0,56,168,0.2)", color: "#0038A8", fontSize: 10, fontWeight: 700, padding: "3px 10px", borderRadius: 20, letterSpacing: 1, textTransform: "uppercase", fontFamily: "'Outfit', sans-serif" }}>
                Session 0{currentSession}
              </div>
              <div className="sd-desktop-avatar" style={{ width: 38, height: 38, borderRadius: "50%", background: "#0038A8", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#fff", fontFamily: "'Outfit', sans-serif" }}>
                {initials || "S"}
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="sd-content">
            {activeView === "home" ? <HomeView /> : <ProgressView />}
          </div>
        </div>

        {/* Mobile Bottom Nav */}
        <div className="sd-bottom-nav">
          <div className="sd-bottom-nav-inner">
            <div className="sd-bottom-item" onClick={() => setActiveView("home")}>
              <div style={{ width: 20, height: 20, borderRadius: 4, background: activeView === "home" ? "#0038A8" : "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ width: 10, height: 10, borderRadius: 2, background: activeView === "home" ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.4)" }} />
              </div>
              <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 9, color: activeView === "home" ? "#0038A8" : "rgba(255,255,255,0.4)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5 }}>Home</span>
            </div>
            <div className="sd-bottom-item" onClick={() => setActiveView("progress")}>
              <div style={{ width: 20, height: 20, borderRadius: "50%", background: activeView === "progress" ? "#C9A84C" : "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ width: 10, height: 10, borderRadius: "50%", background: activeView === "progress" ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.4)" }} />
              </div>
              <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 9, color: activeView === "progress" ? "#C9A84C" : "rgba(255,255,255,0.4)", fontWeight: activeView === "progress" ? 700 : 600, textTransform: "uppercase", letterSpacing: 0.5 }}>Progress</span>
            </div>
            <div className="sd-bottom-item" onClick={handleLogout}>
              <div style={{ width: 20, height: 20, borderRadius: "50%", background: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ width: 10, height: 2, background: "rgba(255,255,255,0.4)", borderRadius: 1 }} />
              </div>
              <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.4)", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>Sign Out</span>
            </div>
          </div>
        </div>

                  {/* GOSECOND Footer */}
        <div style={{
          background: "#060D1A",
          padding: "8px 24px",
          textAlign: "center",
          borderTop: "1px solid rgba(255,255,255,0.05)",
          position: "fixed",
          bottom: 0,
          left: 230,
          right: 0,
          zIndex: 50,
        }} className="sd-footer">
          <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.2)", letterSpacing: 1, textTransform: "uppercase" }}>
            © 2026 GOSECOND INC. All rights reserved.
          </span>
        </div>
      </div>
    </>
  );
}
